<template>
  <div>
    <v-list class="unique-list">
      <v-list-item
        class="d-block px-0"
        v-for="hir in hirek"
        :key="hir.Id"
        :to="{
          name: 'Hir',
          params: {
            id: hir.Azonosito,
          },
        }"
      >
        <v-list-item-content>
          <div class="flex-center-between w-100">
            <div class="d-flex align-center pr-3">
              <v-img
                v-if="hir.Kep"
                height="75px"
                width="100px"
                min-height="75px"
                min-width="100px"
                :src="hir.Kep + '?w=100&h=75'"
                class="mr-4"
              >
              </v-img>
              <div class="d-flex flex-column justify-space-between">
                <v-list-item-title>{{ hir.Cim }}</v-list-item-title>
                <v-list-item-subtitle>
                  <p class="d-flex flex-wrap align-center mb-0">
                    {{ hir.Szerzo.Nev }}
                    <span class="dot-separator grey darken-2 mx-2"></span>
                    <k-live-timestamp
                      :value="hir.MegjelenesDatuma"
                    ></k-live-timestamp>
                  </p>
                </v-list-item-subtitle>
              </div>
            </div>
            <k-fontos-hir-icon color="primary" :hir="hir"></k-fontos-hir-icon>
          </div>
        </v-list-item-content>
        <v-divider></v-divider
      ></v-list-item>
    </v-list>
  </div>
</template>

<script>
import uniqBy from 'lodash/uniqBy';
import { mapGetters } from 'vuex';
import { NotificationFunctions } from '../../functions/NotificationFunctions';

export default {
  name: 'k-more-news-list',
  data() {
    return {
      tovabbiHirekSwiperOptions: {
        spaceBetween: 20,
        speed: 400,
        freeMode: true,
        freeModeSticky: true,
        slidesPerView: 1.6,
        watchOverflow: true,
      },
    };
  },
  mounted() {},
  created() {},
  methods: {},
  computed: {
    ...mapGetters({}),
  },
  watch: {},
  components: {},
  props: {
    hirek: {
      type: Array,
      required: true,
    },
  },
};
</script>
<style scoped lang="scss">
.v-list .v-divider {
  border-color: rgba(0, 0, 0, 0.12) !important;
}
.v-list-item:last-child {
  .v-divider {
    display: none;
  }
}
</style>
